import request, { METHODS } from '@/api'
import UrlConfig from "@/api/UrlConfigs.ts";
import {message} from "antd";

// 查询 通话记录分页
export const getAudioRecordPage = async options => {
  return request(UrlConfig.crmTool.GetAudioRecordPage, {
    method: METHODS.POST,
    ...options,
  })
}
//  通话记录 - 导出
export function exportAudioRecord(params = {}) {
  return request(UrlConfig.crmTool.ExportAudioRecord, {
    method: METHODS.POST,
    data: params,
  })
}

// 通话记录 - 评定
export function audioRecordConformity(params = {}) {
  return request(UrlConfig.crmTool.AudioRecordConformity, {
    method: METHODS.POST,
    data: params,
    raw: true,
  })
}
// 通道回调配置
export const getSeatIpConfigPage = options => {
  return request(UrlConfig.crmTool.GetSeatIpConfigPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSeatIpConfigList = (data = {}) => {
  return request(UrlConfig.crmTool.GetSeatIpConfigList, {
    method: METHODS.POST,
    data,
  })
}
export const seatIpConfigSave = (data = {}) => {
  return request(UrlConfig.crmTool.SeatIpConfigSave, {
    method: METHODS.POST,
    data,
  })
}
export const seatIpConfigDel = id => {
  return request(UrlConfig.crmTool.SeatIpConfigDel + id, {
    method: METHODS.DELETE,
  })
}
export const seatIpConfigUpdate = (data = {}) => {
  return request(UrlConfig.crmTool.SeatIpConfigUpdate, {
    method: METHODS.POST,
    data,
  })
}

// 坐席配置
export const getSeatAccountPage = options => {
  return request(UrlConfig.crmTool.GetSeatAccountPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getSeatAccountList = (data = {}) => {
  return request(UrlConfig.crmTool.GetSeatAccountList, {
    method: METHODS.POST,
    data,
  }).catch(() => {
    message.destroy()
  })
}

export const seatAccountSave = (data = {}) => {
  return request(UrlConfig.crmTool.SeatAccountSave, {
    method: METHODS.POST,
    data,
  })
}
export const seatAccountDel = id => {
  return request(UrlConfig.crmTool.SeatAccountDel + id, {
    method: METHODS.DELETE,
  })
}
export const seatAccountUpdate = (data = {}) => {
  return request(UrlConfig.crmTool.SeatAccountUpdate, {
    method: METHODS.POST,
    data,
  })
}
export const getSeatAccount = (userId) => {
  return request(UrlConfig.crmTool.GetSeatAccount + userId, {
    method: METHODS.GET,
  })
}

// 线路分配
export const getLineAllocationPage = options => {
  return request(UrlConfig.crmTool.GetLineAllocationPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getLineAllocationList = (data = {}) => {
  return request(UrlConfig.crmTool.GetLineAllocationList, {
    method: METHODS.POST,
    data,
  })
}

export const lineAllocationSave = (data = {}) => {
  return request(UrlConfig.crmTool.AddLineAllocation, {
    method: METHODS.POST,
    data,
  })
}
export const lineAllocationDel = id => {
  return request(UrlConfig.crmTool.DeleteLineAllocation + id, {
    method: METHODS.DELETE,
  })
}
export const updateZitongSeatAccount = data => {
  return request(UrlConfig.crmTool.UpdateZitongSeatAccount, {
    method: METHODS.POST,
    data,
  })
}
export const lineAllocationUpdate = (data = {}) => {
  return request(UrlConfig.crmTool.UpdateLineAllocation, {
    method: METHODS.POST,
    data,
  })
}

// 查询 量房管理分页
export const getMeasureRoomPage = options => {
  return request(UrlConfig.crmTool.GetMeasureRoomPage, {
    method: METHODS.POST,
    ...options,
  })
}
export const getMeasureRoomList = data => {
  return request(UrlConfig.crmTool.GetMeasureRoomList, {
    method: METHODS.POST,
    data,
  })
}
export const addMeasurePerson = data => {
  return request(UrlConfig.crmTool.AddMeasurePerson, {
    method: METHODS.POST,
    data,
  })
}
export const modifyMeasurePerson = data => {
  return request(UrlConfig.crmTool.ModifyMeasurePerson, {
    method: METHODS.POST,
    data,
  })
}
export const modifyAppointmentTime = data => {
  return request(UrlConfig.crmTool.ModifyAppointmentTime, {
    method: METHODS.POST,
    data,
  })
}
export const cancelMeasure = data => {
  return request(UrlConfig.crmTool.CancelMeasure, {
    method: METHODS.POST,
    data,
  })
}
export const measurePrepare = data => {
  return request(UrlConfig.crmTool.MeasurePrepare, {
    method: METHODS.POST,
    data,
  })
}
export const measureConfirm = data => {
  return request(UrlConfig.crmTool.MeasureConfirm, {
    method: METHODS.POST,
    data,
  })
}
export const measureSend = id => {
  return request(UrlConfig.crmTool.MeasureSend + id, {
    method: METHODS.GET,
  })
}
export const measureDetail = id => {
  return request(UrlConfig.crmTool.MeasureDetail + id, {
    method: METHODS.GET,
  })
}
export const measureUpdateClueDtl = data => {
  return request(UrlConfig.crmTool.MeasureUpdateClueDtl, {
    method: METHODS.POST,
    data,
  })
}
export const measureRoomConfig = data => {
  return request(UrlConfig.crmTool.MeasureRoomConfig, {
    method: METHODS.POST,
    data,
  })
}
export const measureRoomHouseInspection = data => {
  return request(UrlConfig.crmTool.MeasureRoomHouseInspection, {
    method: METHODS.POST,
    data,
  })
}
export const measureRoomUpdateMeasureDtl = data => {
  return request(UrlConfig.crmTool.MeasureRoomUpdateMeasureDtl, {
    method: METHODS.POST,
    data,
  })
}
export const startMeasureRoomProcess = id => {
  return request(UrlConfig.crmTool.StartMeasureRoomProcess + id, {
    method: METHODS.POST,
  })
}
export const measureRoomStatistics = data => {
  return request(UrlConfig.crmTool.MeasureRoomStatistics, {
    method: METHODS.POST,
    data,
  })
}
export const measureRoomAIPolish = data => {
  return request(UrlConfig.crmTool.MeasureRoomAIPolish, {
    method: METHODS.POST,
    data,
  })
}
export const zhiTongSeatAccountInfo = () => {
  return request(UrlConfig.crmTool.ZhiTongSeatAccountInfo, {
    timeout: 60 * 1000 * 1000,
    method: METHODS.GET,
  }).catch(() => {
    message.destroy()
  })
}
export const zhiTongReturnCall = (clueId) => {
  return request(UrlConfig.crmTool.ZhiTongReturnCall + clueId, {
    timeout: 60 * 1000 * 1000,
    method: METHODS.GET,
  })
}

export const getSeatAccountOne = (data) => {
  return request(UrlConfig.crmTool.GetSeatAccountOne, {
    method: METHODS.POST,
    data,
  }).catch(() => {
    message.destroy()
  })
}

// 查询 通话记录分页-根据客户id
export const getAudioRecordPageByCustomerId = async options => {
  return request(UrlConfig.crmTool.GetAudioRecordPageByCustomerId, {
    method: METHODS.GET,
    ...options,
  })
}